import { defineComponent as _defineComponent } from 'vue'
import { inject } from 'vue';
import UserInfo from '../UserInfo';
import Language from '../../common/Language.vue';
import SwitchTheme from '../../common/SwitchTheme.vue';
import RoomInfo from '../RoomInfo';
import LayoutControl from './LayoutControl.vue';
import NetworkInfo from './NetworkInfo.vue';
import { useBasicStore } from '../../../stores/basic';
import { storeToRefs } from 'pinia';


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  emits: ['log-out'],
  setup(__props) {

const basicStore = useBasicStore();

const { userId, userName, avatarUrl } = storeToRefs(basicStore);

const showHeaderInfo = inject('showHeaderInfo', true);



return { __sfc: true,basicStore, userId, userName, avatarUrl, showHeaderInfo, SwitchTheme, RoomInfo, LayoutControl, NetworkInfo }
}

})